import React, { useContext, useEffect, useState } from "react";
import uuid from "react-uuid";
import FlowContext from "../../../../contexts/flowContext";
import styles from "../controls.module.css";

const defaultFlowName = `Nouveau Flux ${uuid().split("-")[0]}`;

const NewFlow = () => {
  const [flowState, flowDispatcher] = useContext(FlowContext);

  const [flowName, setFlowName] = useState(defaultFlowName);
  const [flowVersion, setFlowVersion] = useState("");

  useEffect(() => {
    if (flowState.name !== flowName) {
      setFlowName(flowState.name);
    }
  }, [flowState.name]);

  useEffect(() => {
    if (flowState.flowVersion !== flowVersion) {
      setFlowVersion(flowState.version);
    }
  }, [flowState.version]);

  useEffect(() => {
    if (flowName && flowState.name !== flowName) {
      flowDispatcher({
        type: "update-flow-name",
        name: flowName,
      });
    }

    if (flowVersion && flowState.version !== flowVersion) {
      flowDispatcher({
        type: "update-flow-version",
        version: flowVersion,
      });
    }
  }, [flowName, flowVersion]);

  const handleNameChange = (e) => {
    setFlowName(e.target.value);
  };

  const handleVersionChange = (e) => {
    setFlowVersion(e.target.value);
  };

  return (
    <div className={styles.input_container}>
      <input
        /* className={`${
          flowName === defaultFlowName ? styles.default_flow_name : ""
        }`} */
        className={styles.input}
        value={flowName || ""}
        size="large"
        placeholder={flowName}
        onChange={handleNameChange}
        disabled={
          !flowState.app ||
          !flowState.brand ||
          !flowState.name ||
          !flowState.version
        }
      />
      <input
        /* className={`${
          flowName === defaultFlowName ? styles.default_flow_name : ""
        }`} */
        className={styles.input}
        value={flowVersion || ""}
        size="large"
        placeholder={flowVersion}
        onChange={handleVersionChange}
        disabled={
          !flowState.app ||
          !flowState.brand ||
          !flowState.name ||
          !flowState.version
        }
      />
    </div>
  );
};

export default NewFlow;
